(function () {
  'use strict';

  angular.module('checker.data', []);

})();
